/**
 * Where the quest preview card goes, from its measured size (Tome UI audit): beside the pointer or
 * anchor, flipped to the other side when the right has no room, kept a margin inside the viewport,
 * and never taller than the viewport (the card clips to `maxHeight`).
 */
export interface Size { width: number; height: number }
export interface PreviewAt {
  pointer?: { x: number; y: number } | null;
  anchor?: { left: number; top: number; right: number; bottom: number } | null;
}

const MARGIN = 12;
const clamp = (value: number, low: number, high: number) => Math.max(low, Math.min(value, high));

export function placePreviewCard(at: PreviewAt, card: Size, view: Size): { left: number; top: number; maxHeight: number } {
  const maxHeight = view.height - 2 * MARGIN;
  const height = Math.min(card.height, maxHeight);
  // [right of, left of, preferred top]
  const beside = at.pointer ? [at.pointer.x + 16, at.pointer.x - 16 - card.width, at.pointer.y - 12]
    : at.anchor ? [at.anchor.right + 12, at.anchor.left - 12 - card.width, at.anchor.top]
      : [MARGIN, MARGIN, MARGIN];
  const [right, left, top] = beside;
  const fitsRight = right + card.width <= view.width - MARGIN;
  return {
    left: clamp(fitsRight ? right : left, MARGIN, Math.max(MARGIN, view.width - MARGIN - card.width)),
    top: clamp(top, MARGIN, view.height - MARGIN - height),
    maxHeight,
  };
}
